import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { NiIconComponent } from '../ni-icon/ni-icon.component'; 

@Component({
  selector: 'NiFormToaster',
  standalone: true,
  imports: [CommonModule, NiIconComponent],
  templateUrl: './ni-toaster.component.html',
  styleUrls: ['./ni-toaster.component.css'],
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ 
          opacity: 0, 
          transform: 'translate3d(0, -20px, 0)' 
        }),
        animate('500ms cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ 
          opacity: 1, 
          transform: 'translate3d(0, 0, 0)' 
        }))
      ]),
      transition(':leave', [
        animate('400ms cubic-bezier(0.55, 0.06, 0.68, 0.19)', style({ 
          opacity: 0, 
          transform: 'translate3d(0, -10px, 0)' 
        }))
      ])
    ]),
    trigger('toastAnimationBottom', [
      transition(':enter', [
        style({ 
          opacity: 0, 
          transform: 'translateX(-50%) translateY(30px) translateZ(0)' 
        }),
        animate('500ms cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ 
          opacity: 1, 
          transform: 'translateX(-50%) translateY(0) translateZ(0)' 
        }))
      ]),
      transition(':leave', [
        animate('400ms cubic-bezier(0.55, 0.06, 0.68, 0.19)', style({ 
          opacity: 0, 
          transform: 'translateX(-50%) translateY(20px) translateZ(0)' 
        }))
      ])
    ])
  ]
})
export class NiToasterComponent implements OnInit, OnDestroy {
  @Input() message: string = '';
  @Input() type: 'success' | 'error' | 'info' = 'success';
  @Output() onClose = new EventEmitter<void>();
  @Input() position: 'top-right' | 'bottom-center' = 'top-right';
  @Input() duration: number = 5000; // Duration in milliseconds

  private timer?: number;
  private progressInterval?: number;
  private startTime: number = 0;
  progressWidth: number = 100;

  ngOnInit() {
    this.startTime = Date.now();
    this.startTimer();
    this.updateProgressBar();
  }

  ngOnDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }

  private startTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    
    this.timer = window.setTimeout(() => {
      this.close();
    }, this.duration);
  }

  private updateProgressBar() {
    // Clear existing interval if any
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }

    this.progressInterval = window.setInterval(() => {
      const elapsed = Date.now() - this.startTime;
      const remainingTime = Math.max(0, this.duration - elapsed);
      this.progressWidth = (remainingTime / this.duration) * 100;

      if (remainingTime <= 0) {
        if (this.progressInterval) {
          clearInterval(this.progressInterval);
          this.progressInterval = undefined;
        }
      }
    }, 16); // ~60fps for smoother animation
  }

  close() {
    this.onClose.emit();
  }

getIcon(): string {
  if (this.type === 'success') {
    return 'successToast';
  }

  if (this.type === 'info') {
    return 'infoToast';
  }

  return 'alertToast';
}


borderClass(): string {
  if (this.type === 'success') {
    return 'toast-success';
  } else if (this.type === 'info') {
    return 'toast-info';
  } else {
    return 'toast-error';
  }
}

getPositionClasses(): string {
  if (this.position === 'bottom-center') {
    return 'bottom-12';
  } else {
    return 'top-[85px] lg:right-4 md:right-4 sm:right-4 xs:right-4 right-2';
  }
}

getZIndexClass(): string {
  return this.position === 'bottom-center' ? 'z-[10000]' : 'z-50';
}

}